<template>
  <v-flex
    v-if="!_.isEmpty(performance)"
    xs12
    md12
    performance
  >
    <v-flex
      xs11
      md11
      style="padding-bottom:0;"
    >
      <bar-chart
        ref="chart"
        :chartdata="chartData"
        :chartoptions="chartOptions"
        :styles="ChartStyles"
      />
    </v-flex>
    <v-layout
      v-for="(year,i) in performance"
      :key="i"
      d-none
      d-sm-flex
      wrap
      :class="currentYear == i ? 'active' : ''"
      @click="changeSeries(i)"
    >
      <span class="year">{{ year.year }}</span>
      <div
        v-for="(item,o) in year.series"
        :key="o"
        class="series"
        :style="!$vuetify.breakpoint.sm ? 'font-size:0.85rem;' : 'font-size:0.75rem;width:6.5%'"
      >
        <span :class="colorPnL(item)">{{ item !== 0 ? item + '%' : '-' }}</span>
      </div>
      <div class="series">
        <span class="total">{{ year.roi.toFixed(2) + '%' }}</span>
      </div>
    </v-layout>
  </v-flex>
  <v-flex
    v-else
    xs12
    md12
    not-found
  >
    <v-icon>mdi-ghost</v-icon>
    <p>{{ $t('rankings.performanceNotFound') }}</p>
  </v-flex>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BarChart from "@/charts/Bar.vue";
import { setTimeout } from "timers";

export default {
  components: {
    BarChart
  },
  props: {
    performance: {
      type: Array,
      default() {
        return []
      },
    }
  },
  data() {
    return {
      name: "TraderPerformance",
      currentYear: 0
    };
  },
  computed: {
    ChartStyles() {
      return {
        height: `300px`,
        position: `relative`
      };
    },
    chartData() {
      return {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        datasets: {}
      };
    },
    chartOptions() {
      return {
        legend: false,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return "PnL: " + tooltipItem.value + "%";
            },
            labelTextColor: function(tooltipItem, chart) {
              return tooltipItem.value >= 0 ? "#75b211" : "#d94040";
            },
            title: function(tooltipItem, chart) {
              return tooltipItem[0].label + ", " + chart.datasets[0].label;
            }
          }
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        }
      };
    }
  },
  mounted() {
    if (!_.isEmpty(this.performance)) {
      this.changeSeries(0);
    }
  },
  methods: {
    filterColors(values) {
      let colors = [];
      values.forEach(item => {
        colors.push(item > 0 ? "#75b211" : "#d94040");
      });
      return colors;
    },
    changeSeries(i) {
      let performance = this.performance[i];
      this.currentYear = i;
      this.chartData.datasets = [
        {
          label: performance.year,
          data: performance.series,
          backgroundColor: this.filterColors(performance.series)
        }
      ];

      if (this.$refs.chart !== undefined) this.$refs.chart.render();
    }
  }
};
</script>

<style lang="scss">
.performance {
  .chart {
    margin-right: 100px;
  }
  .layout {
    &:hover,
    &:active,
    &.active {
      .year {
        color: #9c27b0;
      }
    }
    cursor: pointer;
    padding: 15px 0 15px;
    font-weight: 600;
    .year {
      font-size: 0.92rem;
      margin: 0 16px 0 21px;
      color: #7f97ab;
    }
    .series {
      width: 6.9%;
      font-size: 0.85rem;
      text-align: center;
      .total {
        font-weight: 700;
        color: #7f97ab;
      }
    }
  }
  .performance_note {
    margin: 8px 8px 0;
    display: block;
    color: #7f97ab;
    font-size: 0.78rem;
    i {
      font-size: 0.95rem;
    }
  }
}
</style>
